export const STRIPE_MESSAGE = {
   UPLOAD_FAILED :  'Upload failed. Please try again.',
   SOMETHING_WENT_WRONG: 'Something Went Wrong',
   front: 'front',
   back: 'back',
   default: 'default',
   SUBMIT_DOCUMENTS: 'SUBMIT ADDITIONAL DOCUMENTATION',
   VERIFY_BANK_ACCOUNT: 'VERIFY BANK ACCOUNT',
   HELP: 'Contact Support'
}
export const STRIPE_LABEL = {
    IDENTITY_DOCUMENT: 'identity-document',
    BANK_DOCUMENT:'bank-document',
    COMPANY_DOCUMENT: 'company-document',
    ADDITIONAL_DOCUMENT: 'additional-document',
    FORM_DETAILS: 'form-details',
}
export const STRIPE_API_CONST ={
    IDENTITY_DOCUMENT: 'identity_document',
    FILES: 'files',
    FILE: 'file',
    PURPOSE: 'purpose',
    POST: 'POST',
    ACCOUNT_REQUIREMENT: 'account_requirement'
}
export const FORM_DETAILS = {
    FORM_DETAILS: 'Form Details',
    FOOTER_TEXT: 'Note: Please fill all the details.'
}
export const STRIPE = 'stripe'

export const STRIPE_INFO_MESSAGE = {
    UNDER_REVIEW : 'To protect your account from fraudulent transactions, the 3rd Party payment processor (Stripe.com) has restricted your ability to withdrawal funds until you submit additional identity documents.  Please click the link below to submit these documents.' 
}
export const STRIPE_STATUS = {
    UNDER_REVIEW: 'Under Review',
    PENDING: 'Pending',
    RESUBMIT_REQUIRED : 'Resubmit Required',
    RESTRICTED: 'Restricted',
    VERIFIED: 'Verified',
    UPLOAD_DOCUMENTS: 'Upload Documents'
}